// 1. FRAMEWORKS
import 'angular-material/angular-material.min.css';
import 'bootstrap/less/bootstrap.less';

// 2. THIRD-PARTY LIBRARIES & PLUGINS
import 'toastr/build/toastr.css';
import 'intl-tel-input/build/css/intlTelInput.css';
import 'angular-state-loader/angular-state-loader.css';
import 'angular-bootstrap-lightbox/dist/angular-bootstrap-lightbox.min.css';
import 'angucomplete-alt/angucomplete-alt.css';
import 'angular-material-data-table/dist/md-data-table.min.css';
import 'angular-material-time-picker/dist/md-time-picker.css';
import 'quill/dist/quill.snow.css';
import 'pdfjs-dist/web/pdf_viewer.css';
import '@libs/ng-img-crop/ng-img-crop.css';
import 'jquery-ui/themes/base/resizable.css';
import 'jquery-ui/ui/widgets/draggable.js';
import 'jquery-ui/ui/widgets/resizable.js';
import 'ng-table/bundles/ng-table.min.css';

// 3.CUSTOM APPLICATION STYLES
import '../assets/css/style.css';
import '../assets/css/style.less';
import '../assets/css/lib/material.css';
import '@libs/ui-select/select.min.css';

// --- VENDOR JAVASCRIPT LIBRARIES ---
import 'jquery';
import "bootstrap/dist/js/bootstrap.js";
import 'angular';
import 'angular-animate';
import 'angular-sanitize';
import 'angular-material';
import 'angular-ui-bootstrap';
import '@uirouter/angularjs';
import 'oclazyload';
import 'pdfjs-dist';
import '../libs/ui-select/select';
import 'angular-utf8-base64';
import 'angular-validation';
import 'angular-validation/dist/angular-validation-rule';
import '../libs/ng-img-crop/ng-img-crop';
import 'ng-idle';
import 'angular-bootstrap-lightbox';
import 'angular-touch';
import 'ng-file-upload';
import 'ng-table';
import 'ng-table/bundles/ng-table.min.js';
import 'angular-schema-form';
import 'angular-schema-form-bootstrap';
import 'angular-material-data-table';
import 'angular-ui-sortable';
import 'angular-moment';
import 'ngclipboard';
import 'quill/dist/quill.js';
import 'angucomplete-alt';
import 'intl-tel-input/build/js/utils.js';
import 'pdfjs-dist/build/pdf.mjs';
import 'pdfjs-dist/build/pdf.worker.mjs'
import 'pdfjs-dist/web/pdf_viewer.mjs';
import 'angular-validation-match';
import 'angular-messages'; // for 'ngMessages'
import 'angular-material-time-picker'; // for 'md.time.picker'
import 'ng-focus-if'; // for 'focus-if'
import 'angular-state-loader'; // for 'ec.stateloader'
import 'intl-tel-input';
import 'ng-intl-tel-input/dist/ng-intl-tel-input';
import 'moment';
import 'toastr';

import 'font-awesome/css/font-awesome.css';

// Import config files
import '../config/linkedin.config';
import '../config/globals.config';
import '../config/postJquery.config';

// Make sure these are globally available
window.moment = require('moment');
window.toastr = require('toastr');
import $ from "jquery";

window.$ = $;
window.jQuery = $;

import './common/browser-compat';

// Add these lines to automatically find and load all .html templates
// into the $templateCache via the loaders we configured.
// This is a feature of webpack that allows you to require modules dynamically
// We're using it to load all of our html templates into the $templateCache
const context = require.context('./', true, /\.html$/);
context.keys().forEach(context);

// Import application modules
import './app.module';
import './app.controller';
import './app.routes';
import './app.service';

// Import necessary modules
import '@common/common.module';
import './authentication/authentication.module';


import angular from 'angular';
import { initializeGlobalConfigs } from '../config/globals.config';
import { PDFJS_CONFIG, pdfJsConfiguration } from '@/config/pdf.config';

/**
 * Fetches the application configuration and then bootstraps the Angular application.
 */
function bootstrapApplication() {
    fetch(`/app.config.json?v=${new Date().getTime()}`)
        .then(response => {
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            return response.json();
        })
        .then(config => {
            // Store the full config in a global variable so the app can access it.
            window['ecvConfig'] = config;
            const ecareEnv = config.ecareEnv;
            initializeGlobalConfigs(config);
            window[PDFJS_CONFIG] = new pdfJsConfiguration(ecareEnv);
            // Define Angular constants based on the fetched configuration
            const eCareVaultModule = angular.module('eCareVault');
            eCareVaultModule.constant('authConfig', config.msal);
            eCareVaultModule.constant('storageConfig', config.storage);
            eCareVaultModule.constant('msalZoomConfig', config.zmsal);
            eCareVaultModule.constant('ecareEnv', ecareEnv);
            eCareVaultModule.constant('imgEnv', config.imgEnv);
            eCareVaultModule.constant('baseUrl', (ecareEnv == 'staging' ? 'https://staging.ecarevault.com/' :
                (ecareEnv == 'production' ? 'https://my.ecarevault.com/' :
                    (ecareEnv == 'qa2' ? 'https://qa2.ecarevault.com/' :
                        (ecareEnv == 'ecv-dev' ? 'https://ecv-dev.ecarevault.com' : 'https://jeavio-dev.ecarevault.com')))));

            eCareVaultModule.config(['$httpProvider', ($httpProvider) => {
                $httpProvider.interceptors.push(['$injector', 'authConfig', ($injector, authConfig) => {
                    return {
                        request: (config) => {
                            try {
                                // Get CacheService only when needed and available
                                if (authConfig && authConfig.backendEndPoint &&
                                    config.url.indexOf(authConfig.backendEndPoint) > -1) {

                                    const CacheService = $injector.get('CacheService');
                                    const token = CacheService.getAuthToken();

                                    if (token) {
                                        config.headers = config.headers || {};
                                        config.headers['Authorization'] = "Bearer " + token;
                                        config.headers['Access-Control-Allow-Origin'] = '*';
                                    }
                                }
                            } catch (e) {
                                // Service might not be available yet, continue without auth
                                console.warn('CacheService not available in interceptor:', e);
                            }
                            return config;
                        }
                    };
                }]);
            }]);

            // Manually bootstrap the application on the document
            angular.element(document).ready(() => {
                angular.bootstrap(document, ['eCareVault']);
            });
        })
        .catch(error => {
            console.error('Failed to load configuration. Application cannot start.', error);
            // You could display a user-friendly error message on the page here
            document.body.innerHTML = '<div style="text-align: center; padding-top: 50px;"><h1>Error</h1><p>Application configuration could not be loaded. Please contact support.</p></div>';
        });
}

// Start the process
bootstrapApplication();
